<template>
  <div v-if="isTotals">
    <div class="row justify-content-between text-nowrap">
      <p class="col font-weight-bold mb-1" v-dynamic-content="dc"></p>
      <p class="col font-weight-bold text-right mb-1">{{ price | formatCurrency }}</p>
    </div>
    <p v-if="textMuted" class="mb-1" v-dynamic-content="textMuted"></p>
  </div>
  <div v-else class="row justify-content">
    <span class="col text-nowrap">
      <p v-dynamic-content="dc"></p>
    </span>
    <p class="col text-right">{{ price | formatCurrency }}</p>
  </div>
</template>

<script>
export default {
  props: {
    isTotals: {
      type: Boolean,
      required: false,
      default: false,
    },
    dc: {
      type: Object,
      required: true,
    },
    price: {
      type: [Number, Array, String],
      required: true,
    },
    textMuted: {
      type: Object,
      required: false,
      default: null,
    },
  },
}
</script>
